var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.5 21.387c0-.552.448-1 1-1s1 .448 1 1c0 .553-.448 1-1 1s-1-.447-1-1M15.491 19.145c-.408 0-.738-.33-.738-.738v-.126c-.004-.755-.007-1.694.969-2.632.401-.388.934-.676 1.45-.954 1.233-.666 1.804-1.075 1.71-1.948-.135-1.261-1.6-1.854-2.992-1.882-1.406-.028-2.917.534-3.084 1.661-.06.404-.435.683-.839.623-.403-.06-.682-.436-.622-.84.3-2.02 2.49-2.922 4.448-2.922.042 0 .084 0 .126.002 2.039.04 4.2 1.046 4.432 3.2.21 1.954-1.343 2.794-2.478 3.406-.447.242-.87.47-1.126.717-.522.502-.52.901-.518 1.563v.132c0 .408-.33.738-.738.738",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M21.581 6.518C17.364 4.032 11.844 4.6 8.221 8.222c-4.295 4.296-4.295 11.26 0 15.556 4.297 4.296 11.261 4.296 15.557 0 3.197-3.196 4.015-7.87 2.454-11.823m-1.4-2.515c-.317-.425-.668-.832-1.054-1.218",
    transform: "translate(1 1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.7481c6ff.svg";
export { ForwardRef as ReactComponent };